import {
  faChevronDown,
  faGear,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, ChangeEvent, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useStore } from "../store";
import { getRefineVisualisation, getVisualisation } from "../api/visualisation";
import {
  RefineVisualisationUpload,
  Summary,
  VisualisationUpload,
} from "../entities/entities";
import { useTranslation } from 'react-i18next';
import CreditModal from "./CreditModal"

interface MyFormProps {
  summary: Summary;
  setVisualisationLoading: (isLoading: boolean) => void;
  setVisualisationError: (visualisationError: boolean) => void;
  buttonText: string;
}

function MyForm(props: MyFormProps) {
  const [inputValue, setInputValue] = useState<string>("");
  const { visualisation, setVisualisation } = useStore();
  const { visualisation_image, setVisualisationImage } = useStore();
  const { explanations, setExplanations } = useStore();

  const { code, setCode } = useStore();
  const { instructions, setInstructions } = useStore();
  const { interpretations, setIinterpretations } = useStore();
  const { selectedFileName, setSelectedFileName } = useStore();
  const { selectedGoal, setSelectedGoal } = useStore();
  const { visualisationType, setVisualisationType } = useStore();
  const { 
    visualizationHistory, 
    setVisualizationHistory, 
    setCurrentHistoryIndex 
  } = useStore();
  
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { t } = useTranslation("Form");

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  async function handleSendButtonClick(): Promise<any> {
    try {
      // Handle the logic when the send button is clicked
      setExplanations(null);
      setIinterpretations(null);
      setSelectedGoal({
          question: inputValue,
          visualization: visualisationType,
          rationale: "",}
        );

      const payload: VisualisationUpload = {
        filename: selectedFileName || "",
        goal: {
          question: inputValue,
          visualization: visualisationType,
          rationale: "",
        },
        library: "seaborn",
      };
      props.setVisualisationLoading(true);
      props.setVisualisationError(false);
      const response = await getVisualisation(payload);
      if (response.status === 402) {
        setIsModalOpen(true);
      }
      props.setVisualisationLoading(false);
      setVisualisation(response.data.charts.svg_plot);
      setVisualisationImage(response.data.charts.raster);
      setCode(response.data.charts.code);
      
      // Initialize visualization history
      const historyArray = [{
        code: response.data.charts.code,
        svg: response.data.charts.svg_plot,
        imageBase64: response.data.charts.raster,
        instruction: inputValue
      }];
      setVisualizationHistory(historyArray);
      setCurrentHistoryIndex(0);
      
    } catch (error) {
      props.setVisualisationError(true);
      console.error("Error fetching data:", error);
    }
  }

  async function handleRefineButtonClick(): Promise<any> {
    try {
      // Handle the logic when the send button is clicked
      setExplanations(null);
      setIinterpretations(null);
      // Add your own logic here, such as sending data to a server
      const payload: RefineVisualisationUpload = {
        filename: selectedFileName || "",
        goal: {
          question: selectedGoal!.question,
          visualization: selectedGoal!.visualization,
          rationale: selectedGoal!.rationale,
        },
        code: code,
        instructions: inputValue,
        library: "seaborn",
      };
      props.setVisualisationLoading(true);
      props.setVisualisationError(false);
      const response = await getRefineVisualisation(payload);

      if (response.status === 402) {
        setIsModalOpen(true);
      }

      props.setVisualisationLoading(false);
      setVisualisation(response.data.charts.svg_plot);
      setVisualisationImage(response.data.charts.raster);
      setCode(response.data.charts.code);
      
      // Update visualization history
      const newHistoryItem = {
        code: response.data.charts.code,
        svg: response.data.charts.svg_plot,
        imageBase64: response.data.charts.raster,
        instruction: inputValue
      };
      const updatedHistory = [...(visualizationHistory || []), newHistoryItem];
      setVisualizationHistory(updatedHistory);
      setCurrentHistoryIndex(updatedHistory.length - 1);
      
    } catch (error) {
      props.setVisualisationLoading(false);
      props.setVisualisationError(true);
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    props.buttonText === t("GenerateButton") && setInputValue(instructions);
  }, [instructions]);

  return (
    <>
    <Form
      style={{
        display: "flex",
        width: "100%",
        height: "3rem",
        gap: "2rem",
        margin: "1rem",
      }}
      onSubmit={(e) => {
        e.preventDefault();
        handleSendButtonClick();
      }}
    >
      <Form.Control
        type="text"
        placeholder={t("PlaceholderText")}
        value={inputValue}
        onChange={handleInputChange}
        style={{ borderColor: "green" }}
      />

      <Button
        variant="success"
        onClick={
          props.buttonText === t("GenerateButton")
            ? handleSendButtonClick
            : handleRefineButtonClick
        }
        //style={{ width: "8rem" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
          }}
        >
          {/* <FontAwesomeIcon icon={faWandMagicSparkles} /> */}
          <FontAwesomeIcon
            icon={
              props.buttonText === t('GenerateButton') ? faWandMagicSparkles : faGear
            }
            size="1x"
          />
          <div>{props.buttonText} </div>
        </div>
      </Button>
    </Form>
    
    {isModalOpen && <CreditModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />}
    </>
  );
}

export default MyForm;